<template>
  <div>
    <heard />
    <div class="tableWrapper">
      <el-button type="primary" size="small" class="margin-b-20" @click="add"
        >增加量表</el-button
      >
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="cmTitle" label="量表名" width="180">
          <el-link type="primary" slot-scope="scope" @click="showPage(scope.row)">{{scope.row.cmTitle}}</el-link>
        </el-table-column>
        <el-table-column prop="cmTitle" label="量表类型" width="100">
          <template slot-scope="scope">{{scope.row.rsFlag == 1 ? '自定义量表':"公共量表"}}</template>
        </el-table-column>
        <el-table-column prop="cmDescript" label="介绍">
          <template slot-scope="scoped">
            <div v-html="scoped.row.cmDescript"></div>
          </template>
        </el-table-column>
        <el-table-column prop="opeart" width="300" label="操作">
          <template slot-scope="scoped">
            <el-button
              :disabled="scoped.row.rsFlag == 0"
              size="mini"
              class="margin-r-8"
              type="primary"
              @click="goMake(scoped.row)"
              >制作</el-button
            >
            <el-button 
            :disabled="scoped.row.rsFlag == 0"
            size="mini" class="margin-r-8" type="success"
              >复制</el-button
            >
            <el-button
              size="mini"
              :disabled="scoped.row.rsFlag == 0"

              class="margin-r-8"
              type="danger"
              @click="remove(scoped.row)"
              >删除</el-button
            >
            <el-button size="mini" 
            :disabled="scoped.row.rsFlag == 0"
             type="info" @click="edit(scoped.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :visible.sync="showDialogFlag">
      <el-form :model="form">
        <el-form-item label="名称" label-width="80px">
          <el-input
            v-model="form.cmTitle"
            class="width-300"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="内容" label-width="80px">
          <div id="div1"></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDialogFlag = false" size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="save" size="small">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
       v-if="fullFlag"
      :close-on-press-escape='true'
      :visible.sync="fullFlag"
      :fullscreen="true"
      :testPageTitle="currentItems.cmTitle"
      :before-close="handleCloseFull">
     <testPage :isQueryId="currentItems.id" :testPageTitle="currentItems.cmTitle" :tableData="tableData"  :isQuery ="true"  />
    </el-dialog>
  </div>
</template>

<script>
import testPage from './testPage.vue'
import heard from "../components/heard.vue";
import E from "wangeditor";
import { custom, addcustom, reomveCustom, updateCustom ,uploadFileRich } from "@/utils/custom";
import { mapState } from "vuex";
const resourceUrl = 'https://language.phenxie.com/oss/'
export default {
  components: {
    heard,
    testPage
  },
  mounted() {
    this.getList();
  },
  data() {
    return {
      editor: null,
      pageNum: 1,
      pageSize: 10,
      showDialogFlag: false,
      fullFlag:false,
      form: {
        cmTitle: "",
      },
      isEdit: false,
      currentObj: {},
      tableData: [],
      currentItems:{}
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    showPage(e){
      this.currentItems = e;
      this.fullFlag = true
    },
    handleCloseFull(){
      this.fullFlag = false
    },
    getList() {
      custom(this.pageNum, this.pageSize ,{userId:this.userInfo.userId}).then((res) => {
        this.tableData = res.rows;
      });
    },
    goMake(obj) {
      this.$router.push({
        name: "makCustom",
        query: {
          id: obj.id,
          cmStatus:obj.cmStatus,
          testPageTitle:obj.cmTitle
        },
      });
    },
    save() {
      let params = {
        cmTitle: this.form.cmTitle,
        cmDescript: this.editor.txt.html(),
        userId: this.userInfo.userId,
      };
      if (!params.cmTitle || !params.cmDescript) {
        this.$message.error("名称或内容不能为空");
        return;
      }
      if (this.isEdit) {
        params.id = this.currentObj.id;
      }
      (this.isEdit ? updateCustom : addcustom)(params).then(() => {
        this.showDialogFlag = false;
        this.isEdit = false;
        this.form.cmTitle = "";
        this.editor.destroy();
        this.getList();
      });
    },
    add() {
      this.showDialogFlag = true;
      this.initWangEdit();
    },
    edit(obj) {
      this.isEdit = true;
      this.showDialogFlag = true;
      this.currentObj = obj;
      this.form.cmTitle = obj.cmTitle;
      this.initWangEdit(obj);
    },
    remove(obj) {
      this.$confirm("是否确认删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          reomveCustom(obj.id).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    initWangEdit(obj) {
      this.$nextTick(() => {
        this.editor = new E("#div1");
        (this.editor.config.customUploadImg = function (resultFiles, insertImgFn) {
          let fd = new FormData();
          fd.append("richPic", resultFiles[0]);
          uploadFileRich(fd).then(res=>{
            insertImgFn(resourceUrl + res.data);
          })
        }),
          this.editor.create();
        if (obj && obj.cmDescript) {
          this.editor.txt.html(obj.cmDescript);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.tableWrapper {
  margin-top: 30px;
  padding: 0 20px;
}
.margin-b-20 {
  margin-bottom: 20px;
}
.margin-r-8 {
  margin-right: 8px;
}

.width-300 {
  width: 300px;
}
</style>
